<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/table.json"></i18n>
<i18n src="@/lang/search.json"></i18n>

<template>
  <el-main>
    <component
      :is="require('../_snippets/header_actions/header_actions').default"
    >
      <template slot="button-group">
        <el-button
          type="primary"
          :disabled="edit_mode"
          @click="
            $router.push({ name: 'texts.details', params: { id: 'new' } })
          "
          >{{ $t("actions.new_texts") }}
        </el-button>
      </template>
    </component>
    <br />
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        v-for="(v, k) in type.schema"
        :key="k"
        v-bind="v.props"
        :label="$t('table.' + k)"
        :property="k"
      >
        <template slot-scope="scope">
          <template v-if="v.type === Boolean">
            <el-checkbox
              v-model="scope.row[k]"
              v-if="v.type === Boolean"
              :disabled="scope.row.uuid !== cur_edited"
            />
          </template>
          <template v-else>
            <span
              v-text="scope.row[k]"
              v-if="cur_edited !== scope.row.uuid"
            ></span>
            <el-input v-model="scope.row[k]" v-else-if="v.editable"></el-input>
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.operations')" align="right">
        <template slot="header" slot-scope="scope">
          <el-input
            :key="scope.index"
            size="mini"
            v-model="filter"
            spa-action="find"
            :placeholder="$t('search.placeholder')"
          />
        </template>
        <template slot-scope="scope">
          <el-dropdown
            split-button
            size="small"
            type="info"
            trigger="click"
            @click="
              $router.push({
                name: 'texts.details',
                params: { id: scope.row.uuid }
              })
            "
          >
            {{ $t("actions.view") }}
            <el-dropdown-menu>
              <el-dropdown-item icon="el-icon-delete" disabled
                >{{ $t("actions.delete") }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import DirectoryTexts from "../../store/classes/DirectoryTexts";

export default {
  name: "periods_list",
  data() {
    return {
      type: DirectoryTexts,
      filter: "",
      cur_edited: null,
      edit_mode: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapMutations({
      addNewTexts: "directory_texts_list/addFirst"
    }),
    getData() {
      this.$api.query(this.refetchQueries[0]);
    },
    showBtn(v, in_edit_mode) {
      // return (this.cur_edited !== v.uuid && !in_edit_mode)
      //     || this.cur_edited === v.uuid && in_edit_mode;
    },
    disableBtn(v) {
      // return this.cur_edited !== null && this.cur_edited !== v;
    },
    handleAction(handler) {
      // let h = handler();
      // let notify;
      // if (h instanceof Promise) {
      //     h.then((param) => {
      //         if (/^[0-9a-fA-F]{8}(\-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12}$/.test(param)) {
      //             this.cur_edited = param;
      //         } else {
      //             switch (param) {
      //                 case "saved":
      //                     notify = { type: "success", title: "Success", message: "Period saved" };
      //                     this.edit_mode = false;
      //                     if (this.cur_edited === undefined){
      //                         this.periods.push(this.periods.shift());
      //                     }
      //                     this.cur_edited = null;
      //                     break;
      //                 case 'canceled':
      //                     notify = { type: "info", title: "Canceled", message: "Edit canceled" };
      //                     this.edit_mode = false;
      //                     this.cur_edited = null;
      //                     break;
      //                 case 'deleted':
      //                     notify = { type: "success", title: "Success", message: "Period deleted" };
      //                     this.getData();
      //                     break;
      //                 default: break;
      //             }
      //
      //         }
      //         if (notify){
      //             this.$notify(notify);
      //         }
      //     })
      //         .catch(() => {
      //             if (this.cur_edited === undefined) {
      //                 this.$notify({ type: "info", title: "Canceled", message: "Add new canceled" });
      //                 this.periods.shift();
      //                 this.cur_edited = null;
      //                 this.edit_mode = false;
      //             }
      //         });
      // }
    }
  },
  computed: {
    ...mapState({
      texts: state => state.directory_texts_list.data
    }),
    tableData() {
      return Object.values(this.texts).filter(v => {
        return v.beShownForFilter(this.filter);
      });
    },
    refetchQueries() {
      return [
        {
          query: require("../../graphql/texts/texts_list.graphql"),
          variables: {}
        }
      ];
    }
  }
};
</script>

<style scoped></style>
